export default __webpack_public_path__ + "static/media/join-an-organization-desktop.029e51b3.png";